module.exports = __webpack_public_path__ + "static/media/business-woman-profile-1.c5f9ff03.png";